module.exports = __webpack_public_path__ + "img/lesson-formats.e3e2024.jpg";